import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectAllUploadProgress = (state: RootState) => state.helia.uploadProgress;

export const selectUploadProgressEntries = createSelector(
  selectAllUploadProgress,
  (uploadProgress) => Object.values(uploadProgress)
);
